import { Component, inject, Input, OnInit, output, Signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
  ValidationErrorsComponent
} from '../../../../../../../common/validation-errors/validation-errors.component';
import { ParcelAppEntityParcelWrite } from '../../../../../../../openapi';
import { ParcelItemForm } from '../parcel-item.form';

@Component({
  selector: 'app-parcel-item-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent
  ],
  templateUrl: './parcel-item-form.component.html'
})
export class ParcelItemFormComponent implements OnInit {

  public submit = output<ParcelAppEntityParcelWrite>();

  public cancel = output<void>();

  @Input()
  public form: ParcelItemForm | undefined;

  @Input()
  public edit = false;

  @Input()
  public showCancel = true;

  public onSubmit(): void {
    if (this.form?.valid) {
      this.submit.emit(this.form.value);
      this.form.reset();
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.cancel.emit();
    this.form?.reset();
  }

  public ngOnInit(): void {
  }

}
